<!--
  Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
 
     http://www.apache.org/licenses/LICENSE-2.0
 
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 
   SPDX-License-Identifier: Apache-2.0
-->

<ul class="nav nav-tabs edc-info-modal-tabs__nav" role="tablist">
	<li class="nav-item" role="presentation">
		<button
			type="button"
			class="nav-link active"
			[id]="tabGroupId + '-summary-tab'"
			data-bs-toggle="tab"
			[attr.data-bs-target]="'#' + tabGroupId + '-summary-panel'"
			role="tab"
			[attr.aria-controls]="tabGroupId + '-summary-panel'"
			aria-selected="true"
		>
			{{ 'GENERAL.INFO-TAB-SUMMARY' | translate }}
		</button>
	</li>
	<li class="nav-item" role="presentation">
		<button
			type="button"
			class="nav-link"
			[id]="tabGroupId + '-raw-tab'"
			data-bs-toggle="tab"
			[attr.data-bs-target]="'#' + tabGroupId + '-raw-panel'"
			role="tab"
			[attr.aria-controls]="tabGroupId + '-raw-panel'"
			aria-selected="false"
			tabindex="-1"
		>
			{{ 'GENERAL.INFO-TAB-RAW' | translate }}
		</button>
	</li>
</ul>
<div class="tab-content mt-3 edc-info-modal-tabs__content">
	<div
		class="tab-pane fade show active"
		[id]="tabGroupId + '-summary-panel'"
		role="tabpanel"
		[attr.aria-labelledby]="tabGroupId + '-summary-tab'"
		tabindex="0"
	>
		<ng-content select=".edc-info-modal-tabs__summary"></ng-content>
	</div>
	<div
		class="tab-pane fade edc-info-modal-tabs__raw-pane"
		[id]="tabGroupId + '-raw-panel'"
		role="tabpanel"
		[attr.aria-labelledby]="tabGroupId + '-raw-tab'"
		tabindex="0"
	>
		<ng-content select=".edc-info-modal-tabs__raw"></ng-content>
	</div>
</div>